import React, {Fragment, useEffect, useState} from 'react';

import {InjectedRouter} from 'react-router';
import {
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  UncontrolledDropdown,
} from 'reactstrap';

import {FullHTMLLink} from 'app/components/general/FullHTMLLink';
import {
  cats,
  useKeyboardShortcuts,
} from 'app/general/shortcuts/useKeyboardShortcuts';
import {HELP_URL} from 'app/urls';
import {gt} from 'app/utils/i18n';

import {NUM_MAIN_LINKS, useNavLinks} from './nav_links';
import {ReorderNavTabsModal} from './ReorderNavTabsModal';

type Props = {
  router: InjectedRouter;
  renderRegularLink?: boolean;
};

export const MoreMenu = ({
  router,
  renderRegularLink = false,
}: Props): JSX.Element => {
  const {registerAndEnableShortcuts} = useKeyboardShortcuts();
  const [iscustomModalVisible, showCustomModal] = useState(false);
  const navLinks = useNavLinks('secondary');

  useEffect(() => {
    // usually we register the shortcuts when the file is scaned/executed
    // but here we need first get user custom links then register them in order
    registerAndEnableShortcuts(
      navLinks.map((link, index) => ({
        // assign numbers shortcuts to each navigation link starting from NUM_MAIN_LINKS + 1
        key: (index + 1 + NUM_MAIN_LINKS).toString(),
        name: () => gt('Go to %s page', link.title),
        category: cats.everywhere,
        callback: () => router.push(link.href),
      }))
    );
  }, [navLinks]);

  return (
    <Fragment>
      <UncontrolledDropdown className="d-none d-lg-flex align-items-stretch">
        <DropdownToggle color="link" className="nav-link">
          <span className="outer">
            <span className="inner">
              {gt('More')} <i className="ml-1 fa fa-angle-down" />
            </span>
          </span>
        </DropdownToggle>

        <DropdownMenu>
          {navLinks.map((link) => (
            <DropdownItem
              tag={FullHTMLLink}
              key={link.slug}
              html_url={link.href}
              renderRegularLink={renderRegularLink}
            >
              <i
                className={`${link.iconType || 'fa'} fa-fw fa-${
                  link.icon
                } mr-1`}
              />
              <span>{link.title}</span>
            </DropdownItem>
          ))}
          <DropdownItem divider />
          <DropdownItem key="_help" className="small" href={HELP_URL}>
            <i className="far fa-fw fa-question-circle mr-1" />
            <span>{gt('Help')}</span>
          </DropdownItem>
          <DropdownItem
            key="_customise"
            className="small"
            onClick={() => showCustomModal(true)}
          >
            <i className="far fa-fw fa-compass mr-1" />
            <span>{gt('Customize navigation')}</span>
          </DropdownItem>
        </DropdownMenu>
      </UncontrolledDropdown>
      <ReorderNavTabsModal
        show={iscustomModalVisible}
        onClose={() => showCustomModal(false)}
      />
    </Fragment>
  );
};
